import F from 'offline/filter/constants'
import DB from 'offline/db'
import Plays from 'offline/filter/plays'
import Util from 'offline/util'

function needsContext(filter) {
	return !!(
		(filter.played && filter.played.range && (filter.played.range.from || filter.played.range.to)) ||
		(filter.play && filter.play.count && (filter.play.count.from !== 1 || filter.play.count.to !== 10)) ||
		(filter.play && filter.play.duration && (filter.play.duration.from !== 0 || filter.play.duration.to !== 360)) ||
		(filter.play && filter.play.locations && filter.play.locations.length) ||
		(filter.play && filter.play.nolocation) ||
		(filter.play && filter.play.players && filter.play.players.required && filter.play.players.required.length)
	)
}

function addUserRows(target, rows) {
	for (var i = 0; i < rows.length; i++) {
		var row = rows[i]
		if (!target[row.user]) target[row.user] = {}
		target[row.user][row.game] = row
	}
}

// Port of api/fuel/app/classes/filter/package/games/play/data/plays/user.php
export default {
	require: function(config, filter) { return !filter.play || !filter.play.group || config.ownerType === F.OWNER_USER },
	run: function(filter, data, config, global) {
		global.plays = global.plays || {}
		global.plays.user = {
			all: {},
			context: {}
		}
		if (!global.gameIds || !global.gameIds.length) return

		var playUserIndex = global.userIndex
		if (config.resultType === F.RESULT_PLAY) {
			playUserIndex = []
			var seenUserIds = {}
			for (var i = 0; i < global.resultIndex.length; i++) {
				var play = global.results && global.results[global.resultIndex[i]]
				var userId = play ? parseInt(play.user_id || 0, 10) : 0
				if (!userId || seenUserIds[userId]) continue
				seenUserIds[userId] = true
				playUserIndex.push(userId)
			}
		}
		if (!playUserIndex.length) return

		var allRows = DB.query(
			'SELECT game_id AS game, user_id AS user, SUM(play_count) AS count, SUM(play_length) AS minutes FROM play WHERE game_id IN(' + Util.in(global.gameIds) + ') AND user_id IN(' + Util.in(playUserIndex) + ') GROUP BY game_id, user_id'
		)
		addUserRows(global.plays.user.all, allRows)

		if (needsContext(filter)) {
			var playContextIndex = Plays.forge({
				owner: config.owner,
				sessionID: config.sessionID,
				settings: config.settings,
				can: config.can,
				asIndex: true,
				filter: {
					played: {
						range: filter.played ? filter.played.range : { from: false, to: false }
					},
					play: {
						count: filter.play ? filter.play.count : { from: 1, to: 10 },
						duration: filter.play ? filter.play.duration : { from: 0, to: 360 },
						locations: filter.play ? filter.play.locations : [],
						nolocation: filter.play ? filter.play.nolocation : 0,
						players: filter.play ? filter.play.players : { required: [], together: 0 }
					},
					games: {
						subset: global.resultIndex || []
					}
				}
			}).run()

			if (!playContextIndex || !playContextIndex.length) playContextIndex = [0]

			var contextRows = DB.query(
				'SELECT game_id AS game, user_id AS user, SUM(play_count) AS count, SUM(play_length) AS minutes FROM play WHERE play_id IN(' + Util.in(playContextIndex) + ') GROUP BY game_id, user_id'
			)
			addUserRows(global.plays.user.context, contextRows)
		} else {
			global.plays.user.context = global.plays.user.all
		}
	}
}
